import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import { createFileRoute } from "@tanstack/react-router";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { UserTrackableLinksDetailsActions } from "@/components/assist/user-trackable-links/details/user-trackable-links-details-actions";
import { UserTrackableLinksDetailsDescription } from "@/components/assist/user-trackable-links/details/user-trackable-links-details-description";
import { UserTrackableLinksDetailsLinkInput } from "@/components/assist/user-trackable-links/details/user-trackable-links-details-link-input";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";

import type { JSX } from "react";

const UserTrackableLinksDetailsPageQuery = graphql(`
  query UserTrackableLinksDetailsPageQuery($userTrackableLinkId: Int!) {
    userTrackableLink: usuariosLinksRastreamentos_by_pk(
      codUsuarioLinkRastreamento: $userTrackableLinkId
    ) {
      nome
      ...UserTrackableLinksDetailsDescriptionFragment
      ...UserTrackableLinksDetailsLinkInputFragment
      ...UserTrackableLinksDetailsActionsFragment
    }
  }
`);

const UserTrackableLinksDetailsPage = (): JSX.Element => {
  const { userTrackableLinkId } = Route.useParams();
  const queryResult = useGraphQL(UserTrackableLinksDetailsPageQuery, {
    userTrackableLinkId: parseInt(userTrackableLinkId),
  });

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title={data?.userTrackableLink?.nome ?? "Links com rastreamento"} />
      </HeaderRoot>

      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data?.userTrackableLink ? (
            <div className="flex flex-col gap-6">
              <UserTrackableLinksDetailsDescription data={data.userTrackableLink} />
              <UserTrackableLinksDetailsLinkInput data={data.userTrackableLink} />
              <UserTrackableLinksDetailsActions data={data.userTrackableLink} />
            </div>
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/assist/user-trackable-links/$userTrackableLinkId/",
)({
  component: UserTrackableLinksDetailsPage,
});
